/** Estado de navegación para rutas bajo SalesPosGate */
export const POS_CONFIRMED_STATE = { posConfirmed: true };

export default POS_CONFIRMED_STATE;
